module.exports = __webpack_public_path__ + "img/image 3.4fc52ec5.png";